import { StringParam, ArrayParam, NumericObjectParam } from 'use-query-params'

export const mapQueryParamsType = (filters) => {
  return filters.reduce((acc, filter) => {
    let paramType

    if (filter.type === 'range') paramType = NumericObjectParam
    if (filter.type === 'select') paramType = ArrayParam
    if (filter.type === 'checkbox') paramType = ArrayParam

    return { ...acc, [filter.name]: paramType ? paramType : StringParam }
  }, {})
}
